import { Application } from '@frontend/functionality/types';
import { Outlet } from 'react-router-dom';

import { ApplicationBundleUsageBanner } from './application-bundle-usage-banner.component';
import { useApplicationBundleUsageLayout } from './application-bundle-usage-layout.controller';

const ID = 'application-bundle-usage-layout';

export interface ApplicationBundleUsageLayoutProps {
    application: Application;
}

export const ApplicationBundleUsageLayout = ({ application }: ApplicationBundleUsageLayoutProps) => {
    const viewProps = useApplicationBundleUsageLayout(application);

    return (
        <div
            id={ID}
            className='flex flex-col'>
            {viewProps.showBanner && viewProps.banner && (
                <ApplicationBundleUsageBanner
                    application={application}
                    banner={viewProps.banner}
                    onDismiss={viewProps.onDismiss}
                />
            )}
            <Outlet />
        </div>
    );
};
